// Exportada: o realce em negrito da coluna "Diferença" (ValidacaoPu.jsx) usa
// o mesmo número de casas.
export const PU_DIFF_CASAS = 3;
const PU_DIFF_EPSILON = 1e-9; // evita truncar errado por ruído de ponto flutuante perto do limite das 3 casas

// Considera divergente só quando |diferenca| truncado em 3 casas decimais for
// > 0 — decisão tomada aqui (não usa `sp.is_igual` da API, que vem com
// precisão cheia) porque essa tolerância é específica desta tela.
function diffSignificativa(diferenca) {
  if (diferenca == null) return false;
  return Math.trunc(Math.abs(diferenca) * 10 ** PU_DIFF_CASAS + PU_DIFF_EPSILON) > 0;
}

// Diferença usada em toda a tela (status, coluna "Diferença", ranking) — quando
// falta o PU da Securitizadora mas o do Agente F. já foi publicado, a API manda
// `diferenca: null` (não tem os dois lados pra subtrair), mas isso não significa
// "igual": trata o lado ausente como 0 (0 - pu_agente_fiduciario) pra refletir
// que há, sim, uma divergência a ser resolvida. Quando é o PU do Agente F. que
// falta, não há o que comparar — permanece null (série cai em 'neutro' em
// `puSplitStatus`, não em 'divergente').
export function diferencaEfetiva(sp) {
  if (!sp) return null;
  if (sp.diferenca != null) return sp.diferenca;
  if (sp.pu_securitizadora == null && sp.pu_agente_fiduciario != null) return -sp.pu_agente_fiduciario;
  return null;
}

// 'igual' (PUs batem, considerando a tolerância de 3 casas) | 'divergente'
// (ambos preenchidos e diferentes acima da tolerância) | 'neutro' (sem PU do
// agente — não integrado ou não publicou hoje) | null (sem dado de validação
// pra esse split). `sp` é um item de `series[]` da resposta de
// /v1/pu-validacao-agente-fiduciario.
export function puSplitStatus(sp) {
  if (!sp) return null;
  if (sp.pu_agente_fiduciario == null) return 'neutro';
  return diffSignificativa(diferencaEfetiva(sp)) ? 'divergente' : 'igual';
}

const SEVERITY = { divergente: 3, neutro: 2, igual: 1 };

// Pior status entre uma lista — usado pra colorir um valor agregado (soma de
// várias séries) pelo pior caso: divergência > sem verificação > igual.
export function worstPuStatus(statuses) {
  const valid = statuses.filter(Boolean);
  if (!valid.length) return null;
  return valid.reduce((worst, s) => SEVERITY[s] > SEVERITY[worst] ? s : worst);
}

// Chave em STATUS (components/UI/index.jsx) que corresponde a cada status —
// reaproveita as cores já definidas lá (verde/vermelho/cinza) em vez de duplicar.
export const PU_STATUS_UI_KEY = { igual: 'enquadrado', divergente: 'desenquadrado', neutro: 'neutro' };
export const PU_STATUS_LABEL  = { igual: 'Igual', divergente: 'Divergente', neutro: 'Sem verificação' };
